import React, { useEffect, useState, useContext } from "react";
import { Button, message } from "antd";
import MDWaitingTime from "../modal/waitingtime";
import Baner from "./../../../assets/suc-khoe-vang/baner.png";
import Intro2 from "./../../../assets/suc-khoe-vang/intro2.png";
import Quytrinhbaolanh from "./../../../assets/suc-khoe-vang/quytrinhbaolanh.png";
import Intro4 from "./../../../assets/suc-khoe-vang/intro4.png";
import Zalo from "./../../../assets/suc-khoe-vang/zalo.png";
import Phone from "./../../../assets/suc-khoe-vang/phone.png";
import Email from "./../../../assets/suc-khoe-vang/email.png";
import Iconi from "./../../../assets/suc-khoe-vang/iconi.png";
import DTthamgia from "./../../../assets/suc-khoe-vang/doituongthamgia.png";
import IthamgiaActive from "./../../../assets/suc-khoe-vang/ithamgiaActive.png";
import Ithamgia from "./../../../assets/suc-khoe-vang/ithamgia.png";
import IloaitruActive from "./../../../assets/suc-khoe-vang/IloaitruActive.png";
import Iloaitru from "./../../../assets/suc-khoe-vang/Iloaitru.png";
import DTloaitru from "./../../../assets/suc-khoe-vang/doituongloaitru.png";
import helper_center from "./../../../extra/helper";
import Chevronmo from "./../../../assets/suc-khoe-vang/chevronmo.png";
import Ql1 from "./../../../assets/suc-khoe-vang/ql1.png";
import Ql2 from "./../../../assets/suc-khoe-vang/ql2.png";
import QLBS1 from "./../../../assets/suc-khoe-vang/qlbs1.png";
import QLBS2 from "./../../../assets/suc-khoe-vang/qlbs2.png";
import QLBS3 from "./../../../assets/suc-khoe-vang/qlbs3.png";
import Chevrondong from "./../../../assets/suc-khoe-vang/chevrondong.png";
import Chitiet from "./../../../assets/suc-khoe-vang/chitiet.png";
import LinkView from "./../modal/linkView";
import Service from "./../../../extra/getAPI";
import MDCompanyInfo from "../modal/mdCompanyInfo";

import { AuthContext } from "./../index";

const Introduce = () => {
  const { OpenLink, goStep, setVAT, setDataIsu, setListIsu, MessageErr } =
    useContext(AuthContext);
  const platform = helper_center.getParamUrlByKey("platform");
  const [open, setOpen] = useState({
    doituongthamgia: true,
    doituongloaitru: false,
    quyenloibh: false,
    qlbs: false,
    nguoiduocBH: false,
    thoigiancho: false,
  });
  const [openWaitingTime, setOpenWaitingTime] = useState(false);
  const [openCompanyInfo, setOpenCompanyInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openLink, setOpenLink] = useState(false);
  const [url, setUrl] = useState({
    link: "",
    title: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    const dataIsu = JSON.parse(localStorage.getItem("dataIsuVbiCare"));
    const listInsured = JSON.parse(localStorage.getItem("listInsuredVBICare"));
    const vat = JSON.parse(localStorage.getItem("vatVBICare"));
    getVerifyToken();
    if (dataIsu) {
      setDataIsu(dataIsu);
    }
    if (listInsured) {
      setListIsu(listInsured);
    }
    if (vat) {
      setVAT(vat);
    }
  }, []);

  // Lấy phí bảo hiểm
  const getVerifyToken = () => {
    setLoading(true);
    Service.apicallNoBase64("GET", `/api/v1/auth/verify-token`)
      .then((res) => {
        setLoading(false);
        if (res?.data?.statusCode === 200) {
          setLoading(false);
        } else {
          MessageErr("Session hết hạn, vui lòng thử lại.");
        }
      })
      .catch((err) => {
        MessageErr("Session hết hạn, vui lòng thử lại.");
      });
  };

  const handleCancel = () => {
    setOpenWaitingTime(false);
    setOpenLink(false);
    setOpenCompanyInfo(false);
  };

  const css = {
    link: {
      padding: 10,
      alignItems: " center",
      background: "#FFFFFF",
      display: "flex",
      justifyContent: "space-between",
    },
    btn: {
      color: "#009B4B",
      background: "#FFF",
      fontWeight: "bold",
      width: "100%",
      height: "44px",
      borderRadius: 8,
      border: "1px solid #009B4B",
    },
    line: { width: "100%", height: 5, background: "#f1f1f1" },
    tabs: {
      width: "50%",
      padding: "5px 10px",
      textAlign: "center",
    },
  };

  return (
    <div style={{ overflow: "hidden" }}>
      <MDWaitingTime
        isModalVisible={openWaitingTime}
        handleCancel={handleCancel}
      />
      <LinkView
        title={url.title}
        isModalVisible={openLink}
        handleCancel={handleCancel}
        url={url.link}
      />
      <MDCompanyInfo
        open={openCompanyInfo}
        handleCancel={handleCancel}
      />
      <img
        loading="lazy"
        style={{ width: "100%" }}
        src={Baner}
        alt="Global Care"
      />
      <div style={css.line}></div>
      <div>
        <div style={{ display: "flex" }}>
          <div
            onClick={() => {
              setOpen({
                ...open,
                doituongthamgia: true,
                doituongloaitru: false,
              });
            }}
            style={{
              ...css.tabs,
              borderBottom: open.doituongthamgia
                ? "2px solid green"
                : "2px solid #f1f1f1",
            }}
          >
            <img
              src={open.doituongthamgia ? IthamgiaActive : Ithamgia}
              style={{ padding: 12, width: 144 }}
            />
          </div>
          <div
            onClick={() => {
              setOpen({
                ...open,
                doituongthamgia: false,
                doituongloaitru: true,
              });
            }}
            style={{
              ...css.tabs,
              borderBottom: open.doituongloaitru
                ? "2px solid green"
                : "2px solid #f1f1f1",
            }}
          >
            <img
              src={open.doituongloaitru ? IloaitruActive : Iloaitru}
              style={{ padding: 12, width: 131 }}
            />
          </div>
        </div>
        <div>
          <img
            src={open.doituongthamgia ? DTthamgia : DTloaitru}
            style={{ padding: 12, width: "100%" }}
          />
        </div>
      </div>
      <div style={css.line}></div>
      <img style={{ width: "100%" }} src={Intro2} alt="Global Care" />
      <div style={css.line}></div>
      <div
        onClick={() => {
          setOpen({ ...open, quyenloibh: !open.quyenloibh });
        }}
        style={{
          ...css.link,
        }}
      >
        <span style={{ fontSize: 16, color: "#009B4B", fontWeight: 700 }}>
          Quyền lợi bảo hiểm
        </span>
        <img
          src={open.quyenloibh ? Chevrondong : Chevronmo}
          style={{ width: 10 }}
        />
      </div>
      <div style={{ padding: 10, display: open.quyenloibh ? "" : "none" }}>
        <img loading="lazy" src={Ql1} style={{ width: "100%" }} />
        <img
          loading="lazy"
          src={Ql2}
          style={{ width: "100%", marginTop: 10 }}
        />
      </div>
      <div style={css.line}></div>
      <div
        onClick={() => {
          setOpen({ ...open, qlbs: !open.qlbs });
        }}
        style={{
          ...css.link,
        }}
      >
        <span style={{ fontSize: 16, color: "#009B4B", fontWeight: 700 }}>
          Quyền lợi bổ sung
        </span>
        <img src={open.qlbs ? Chevrondong : Chevronmo} style={{ width: 10 }} />
      </div>
      <div
        style={{
          padding: 10,
          display: open.qlbs ? "" : "none",
          textAlign: "center",
        }}
      >
        <img loading="lazy" src={QLBS1} style={{ width: "100%" }} />
        <img
          loading="lazy"
          src={QLBS2}
          style={{ width: "100%", marginTop: 10 }}
        />
        <img
          loading="lazy"
          src={QLBS3}
          style={{ width: "55%", marginTop: 10 }}
        />
      </div>
      <div style={css.line}></div>
      <div onClick={() => setOpenWaitingTime(true)} style={css.link}>
        <div>
          <img src={Iconi} style={{ width: 25, marginRight: 7 }} />
          <span>Thời gian chờ</span>
        </div>
        <img src={Chitiet} style={{ width: 7 }} />
      </div>
      <div style={css.line}></div>
      <div
        onClick={() => {
          // setOpenLink(true);
          // setUrl({
          //   link: "https://cdn.globalcare.vn/private/document/pdf/vbi-cares/vietinbank/Quy_tac_BH_VBI_care.pdf",
          //   title: "Điều kiện, điều khoản",
          // });
          OpenLink(
            "https://cdn.globalcare.vn/private/document/pdf/vbi-cares/vietinbank/Quy_tac_BH_VBI_care.pdf"
          );
        }}
        style={css.link}
      >
        <div>
          <img src={Iconi} style={{ width: 25, marginRight: 7 }} />
          <span>Chi tiết điều kiện và điều khoản bảo hiểm.</span>
        </div>
        <img src={Chitiet} style={{ width: 7 }} />
      </div>
      <div style={css.line}></div>
      <div
        onClick={() => {
          // setOpenLink(true);
          // setUrl({
          //   link: "https://cdn.globalcare.vn/private/document/pdf/vbi-cares/vietinbank/Danh_sach_Bao_lanh_vien_phi_150124.pdf",
          //   title: "Danh sách bệnh viện",
          // });
          OpenLink(
            "https://cdn.globalcare.vn/private/document/pdf/vbi-cares/vietinbank/Danh_sach_Bao_lanh_vien_phi_150124.pdf"
          );
        }}
        style={css.link}
      >
        <div>
          <img src={Iconi} style={{ width: 25, marginRight: 7 }} />
          <span>Danh sách bệnh viện liên kết</span>
        </div>
        <img src={Chitiet} style={{ width: 7 }} loading="lazy" />
      </div>
      <div style={css.line}></div>
      <div
        onClick={() => {
          setOpenCompanyInfo(true);
        }}
        style={css.link}
      >
        <div>
          <img src={Iconi} style={{ width: 25, marginRight: 7 }} />
          <span>Thông tin công ty bảo hiểm</span>
        </div>
        <img src={Chitiet} style={{ width: 7 }} loading="lazy" />
      </div>
      <div style={css.line}></div>
      <img
        style={{ width: "100%" }}
        src={Quytrinhbaolanh}
        alt="Global Care"
        loading="lazy"
      />
      <div style={css.line}></div>
      <img
        style={{ width: "100%", padding: "10px 0px 0px 0px" }}
        src={Intro4}
        alt="Global Care"
        loading="lazy"
      />
      <div style={{ background: "#f1f1f1", padding: 10 }}>
        <div style={{ textAlign: "center", fontWeight: 600, marginTop: 10 }}>
          Liên hệ CSKH để được <span style={{ color: "#009B4B" }}>hỗ trợ</span>{" "}
          và <span style={{ color: "#009B4B" }}>hướng dẫn.</span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            margin: "10px 10px 86px 10px",
          }}
        >
          <img
            onClick={() => {
              if (platform === "app") {
                window.ReactNativeWebView.postMessage("/gotozalo");
              } else {
                window.open(
                  "https://chat.zalo.me/?c=648487566003209799",
                  "_blank"
                );
              }
            }}
            style={{ width: 45 }}
            src={Zalo}
            alt="Global Care"
          />
          <a href="tel:1900292987">
            <img style={{ width: 45 }} src={Phone} alt="Global Care" />
          </a>
          <a onClick={() => window.open("mailto:cskh@globalcare.vn", "_blank")}>
            <img style={{ width: 45 }} src={Email} alt="Global Care" />
          </a>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          position: "fixed",
          width: "100%",
          maxWidth: 800,
          bottom: 0,
          height: 76,
          background: "#fff",
          borderRadius: "16px 16px 0px 0px",
          alignItems: "center",
          boxShadow: "0px -4px 8px 0px #0000001A",
          padding: "0px 10px",
        }}
      >
        <Button
          loading={loading}
          onClick={() => goStep(2)}
          style={{ ...css.btn, color: "#fff", background: "#009B4B" }}
          type="#009B4B"
        >
          Tham gia ngay
        </Button>
      </div>
    </div>
  );
};

export default Introduce;
